import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Brightness1 } from '@mui/icons-material';
import { Divider, Grid } from '@mui/material';

import S from 'commons/styles/sto-list-page.styles';
import { STOItem } from 'commons/types';
import { STO_RECEIVE_ROUTES } from 'routes/constants';

interface ISTOReceiveListTableProps {
  stoItems: STOItem[];
}

export const STOReceiveListTable: React.FC<ISTOReceiveListTableProps> = ({
  stoItems,
}) => {
  const navigate = useNavigate();

  return stoItems.map((item, idx) => {
    const receivedProgress = item.receive_actual.reduce(
      (sum, receiveActual) => sum + receiveActual.quantity,
      0,
    );

    const colorProgress =
      receivedProgress === 0
        ? S.colors.PROGRESS_ICON_COLOR[0]
        : receivedProgress !== item.quantity
        ? S.colors.PROGRESS_ICON_COLOR[2]
        : S.colors.PROGRESS_ICON_COLOR[1];
    const skuButtonText = receivedProgress === 0 ? 'RECEIVE SKU' : 'EDIT SKU';

    return (
      <Grid container>
        <S.SKUGridWrapper container>
          <S.SKUGrid
            className="bold"
            item
            xs={8}
            data-testid={`TextListSKU-${idx + 1}`}
          >
            {item.sku_code}
            <S.ProgressSpan data-testid={`TextListQTYReceived-${idx + 1}`}>
              <Brightness1 style={{ fontSize: 11, color: colorProgress }} />{' '}
              {receivedProgress}/{item.quantity}
            </S.ProgressSpan>
          </S.SKUGrid>
          <S.SKUButtonGrid item xs={4}>
            <S.SecondaryButton
              onClick={(): void =>
                navigate(STO_RECEIVE_ROUTES.ITEM, {
                  state: { pickIdx: idx },
                })
              }
              data-testid={`BtnListReceive-${idx + 1}`}
            >
              {skuButtonText}
            </S.SecondaryButton>
          </S.SKUButtonGrid>
          <S.SKUGrid xs={12}>
            STO Number: <S.STONumberText>{item.sto_number}</S.STONumberText>
          </S.SKUGrid>
          <S.SKUGrid item xs={12}>
            <Divider variant="fullWidth" style={{ paddingTop: '12px' }} />
          </S.SKUGrid>
        </S.SKUGridWrapper>
      </Grid>
    );
  });
};
